import { Company, ManualVerificationStatus } from "models/Company"
import {Link} from "react-router-dom"
import { UrlPath } from "utility/routes"

const CompanyAccessItem: React.FC<{company: Company}> = ({company}) => {
 
  return (
    <div className="card mt-4">
      <div className="card-body d-lg-flex justify-content-between align-items-stretch">
        <div className="text-center flex-grow-1 pb-2">
          <h2 className="h2">{company.name}</h2>
          <p className="mb-0 text-secondary">Org nr: {company.companyCode}</p>
          <p className="text-secondary">
            Juridisk navn: {company.legalName}
          </p>
          {company.manualVerificationStatus === ManualVerificationStatus.Pending && <p className="text-danger mb-4">Lagrede endringer venter på godkjenning</p>}
          <p className="mt-3 mb-3">
            <Link
              to={`${UrlPath.Account.Company}/${company.id}`}
              key={company.id}
              className="btn btn-primary text-white"
            >
              Endre opplysninger
            </Link>
          </p>
        </div>
        <div className="d-flex justify-content-center align-items-center cc-company-options">
          <ul className="list-unstyled cc-icon-list mb-3">
              {!company.hasProducts ? 
              <li><i className="bi bi-graph-up-arrow"></i> Produkter </li> :
              <li>
              <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.Products}`}>
                <i className="bi bi-box"></i> Produkter
              </Link></li> }
            {/* <li>
              <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.Invoices}`}>
                <i className="bi bi-file-ruled"></i> Faktura
              </Link>
            </li> */}
            {/* <li>
              <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.AccessManagement}`}>
                <i className="bi bi-person-check"></i> Endringstilgang
              </Link>
            </li> */}
            {/* <li>
              <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.Logg}`}>
                <i className="bi bi-clock-history"></i> Endringslogg
              </Link>
            </li> */}
            {/* <li>
              <Link to={UrlPath.Account.CompanyEdit}>
                <i className="bi bi-file-text"></i> Avtalevilkår
              </Link>
            </li> */}
            <li>
              <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.Statistics}`} state={{ iframeContent: "statistics" }}>
                <i className="bi bi-graph-up-arrow"></i> Statistikk
              </Link>
            </li>
            {/* <li>
              <Link to={UrlPath.Account.CompanyEdit}>
                <i className="bi bi-search"></i> Resultatside 1881.no{" "}
              </Link>
            </li> */}
            <li>
              <Link to={`${UrlPath.Account.Company}/${company.id}/${UrlPath.Account.Actions.InfoSite}`} state={{ iframeContent: "infosite" }}>
                <i className="bi bi-info-square"></i> Infoside 1881.no
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default CompanyAccessItem